import PropTypes from 'prop-types';

// import styling of the component:
import Styled from './table-search-input-style';

/**
 * LineInput component for generic use in Table component.
 *
 * @param {object} props - Props of the component.
 * @param {string} props.icon - Icon to display in the input.
 * @param {string} props.inputStyle - Margin of the input.
 * @param {string} props.customStyle - Width of the input.
 * @param {Function} props.onChange - Function to call when the input is clicked.
 * @param {string} props.name - Name of the input.
 * @param {string} props.label - Label of the input.
 * @param {string} props.type - Type of the input.
 * @param {boolean} props.autoFocus - Autofocus the input.
 * @param {string} props.value - Value of the input.
 * @returns {JSX.Element}
 */
const SearchInput = ({
  name,
  label,
  icon,
  type,
  customStyle,
  onChange,
  inputStyle,
  autoFocus,
  value,
}) => (
  <Styled.Container main {...customStyle}>
    <Styled.Container {...customStyle}>
      <Styled.SearchIcon size={20} />
      <Styled.StyledInput
        name={name}
        label={label}
        placeholder={label}
        type={type}
        onChange={onChange}
        style={inputStyle}
        autoFocus={autoFocus}
        value={value}
      />
      <Styled.Icon>{icon}</Styled.Icon>
    </Styled.Container>
  </Styled.Container>
);

SearchInput.defaultProps = {
  icon: null,
  customStyle: {},
  onChange: null,
  inputStyle: {},
  autoFocus: false,
  value: '',
};

SearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element,
  type: PropTypes.string.isRequired,
  customStyle: PropTypes.shape({
    width: PropTypes.string,
    margin: PropTypes.string,
  }),
  onChange: PropTypes.func,
  inputStyle: PropTypes.shape({
    width: PropTypes.string,
    margin: PropTypes.string,
  }),
  autoFocus: PropTypes.bool,
  value: PropTypes.string,
};

export default SearchInput;
